import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * AD Object SID field definition
 * Free-text input (no preset values)
 */
export const ADObjectSID: SimpleFilterDefinition = {
  apiField: 'sid',
  uiField: 'SID',
  inputType: 'text', // Text input, no dropdown
  operators: [
    'is',
    'is not',
    'contains',
    'does not contain',
    'starts with',
    'ends with',
  ],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'SID',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'sid',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
